
export { default as T } from "./T.js"
export { default as always } from "./always.js"
export { default as append } from "./append.js"
export { default as applySpec } from "./applySpec.js"
export { default as both } from "./both.js"
export { default as chain } from "./chain.js"
export { default as complement } from "./complement.js"
export { default as cond } from "./cond.js"
export { default as dissoc } from "./dissoc.js"
export { default as dropLast } from "./dropLast.js"
export { default as either } from "./either.js"
export { default as equals } from "./equals.js"
export { default as filter } from "./filter.js"
export { default as flip } from "./flip.js"
export { default as identity } from "./identity.js"
export { default as ifElse } from "./ifElse.js"
export { default as includes } from "./includes.js"
export { default as is } from "./is.js"
export { default as isEmpty } from "./isEmpty.js"
export { default as isNil } from "./isNil.js"
export { default as join } from "./join.js"
export { default as juxt } from "./juxt.js"
export { default as lte } from "./lte.js"
export { default as map } from "./map.js"
export { default as mergeDeepLeft } from "./mergeDeepLeft.js"
export { default as mergeLeft } from "./mergeLeft.js"
export { default as path } from "./path.js"
export { default as pick } from "./pick.js"
export { default as pipe } from "./pipe.js"
export { default as prop } from "./prop.js"
export { default as propSatisfies } from "./propSatisfies.js"
export { default as reduce } from "./reduce.js"
export { default as split } from "./split.js"
export { default as test } from "./test.js"
export { default as toLower } from "./toLower.js"
export { default as toPairs } from "./toPairs.js"
export { default as when } from "./when.js"